let _apiUrl = process.env.TABEEB_API_URL

export function getApiUrl(apiUrl) {
  return _apiUrl
}

export function setApiUrl(apiUrl) {
  _apiUrl = apiUrl
}
